export function isPresentationPath(pathname: string): boolean {
  return /^\/(?:s|shared_video|w)\/[^/]+/.test(pathname)
    || /^\/playlist\/(?:p|preview)\/[^/]+/.test(pathname)
    || /^\/members\/[^/]+/.test(pathname);
}
